import { useEffect } from 'react';

export function useG4Pixel(hasLoaded: boolean, g4PixelId?: string) {
  useEffect(() => {
    if (!hasLoaded || !g4PixelId) {
      return;
    }

    const scriptElement = document.createElement('script');

    scriptElement.async = true;
    scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${g4PixelId}`;
    document.head.appendChild(scriptElement);

    const gtagScript = document.createElement('script');
    const gtagInlineScript =
      document.createTextNode(`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        ${g4PixelId ? `gtag('config', '${g4PixelId}');` : ''}
        gtag('send','pageview')
      `);

    gtagScript.appendChild(gtagInlineScript);
    document.head.appendChild(gtagScript);
  }, [g4PixelId, hasLoaded]);
}
